// EMBA E118 班級活動歷程 — 真實資料
//
// 新增活動時：
//   (1) 在這加一筆（必填：id / date / dateLabel / title / titleEn / location / summary / highlights / tint）
//   (2) driveFolderId 寫 Drive 子資料夾 ID（沒照片時留 null 或省略）
//
// schema 設計：
//   - 沒有 weather / participants / host / industries / sponsors 等欄位（user 不需要）
//   - cohortBand: "south" | "north" | "all"（南班 / 北班 / 全班），影響 detail 頁顯示
//   - tint: 給沒有照片時的色塊配色（warm/cool/green/sand/ash/rose 六選一）

export const ACTIVITIES = [
  {
    id: "2026-07-25-26-new-student-camp",
    date: "2026-07-25",
    dateLabel: "2026.07.25–26",
    dateLong: "July 25–26, 2026",
    title: "E118 新生營",
    titleEn: "E118 Orientation Camp",
    cohortBand: "all", // 全班
    category: "gathering",
    summary:
      "七月二十五、二十六日，E118 新生營。\n\n從初次破冰、分組相識到晚會，\n這兩天的照片與精華影片，都留在這裡。",
    highlights: [
      "E118 新生營",
      "兩日活動紀錄",
      "攝影師原始照片與精華影片",
    ],
    tint: "green",
    // 完整原始檔保留在 Jerry 5TB；僅全班 Google 群組可檢視。
    driveFolderId: "1wQsisuZ4tns8DuW_HvzGm8ceeVwXqJ7f",
    albumLabel: "官方版相簿",
    additionalAlbums: [
      { label: "同學版相簿", driveFolderId: "1nYBVPSe7WmLTADzwYMMKdbaFcs6fq81z" },
    ],
    coverImage: "/images/new-student-camp/e118-camp-class-group.jpg",
    // 班網公開的低解析精選照；每次載入隨機顯示其中三張。
    previewPhotos: [
      "/images/new-student-camp/e118-camp-class-group.jpg",
      "/images/new-student-camp/e118-group-lideer.jpg",
      "/images/new-student-camp/day1-team.jpg",
      "/images/new-student-camp/day2-stage.jpg",
      "/images/new-student-camp/day2-outdoor.jpg",
      "/images/new-student-camp/day2-team.jpg",
      "/images/new-student-camp/evening-group.jpg",
      "/images/new-student-camp/evening-cheers.jpg",
      "/images/new-student-camp/evening-stage.jpg",
    ],
  },
  {
    id: "2026-06-27-north-welcome-dinner",
    date: "2026-06-27",
    dateLabel: "2026.06.27",
    dateLong: "June 27, 2026",
    title: "北班迎新晚宴",
    titleEn: "Northern Cohort Welcome Dinner",
    cohortBand: "north", // 北班
    category: "gathering",
    location: "台北 · 凱撒大飯店",
    summary:
      "六月二十七日，北班迎新，席設台北凱撒。\n初入 E118，多是新面孔。\n\n名字還對不上臉，\n一頓晚宴的工夫，便慢慢熟了。",
    highlights: [
      "北班迎新",
      "凱撒大飯店晚宴",
      "新同學相互認識",
    ],
    tint: "rose",
    driveFolderId: "1CkBx721ZIEQxTINIG1SWHkFHUTHj8AgM",
  },
  {
    id: "2026-05-23-south-cohort-dinner",
    date: "2026-05-23",
    dateLabel: "2026.05.23",
    dateLong: "May 23, 2026",
    title: "南班餐敘 · 夏林海產",
    titleEn: "Southern Cohort Gathering",
    cohortBand: "south", // 南班
    category: "gathering",
    location: "台南 · 夏林海產",
    summary:
      "課程將近，南班於夏林海產小聚。\n六桌長席，自暮入夜。\n\n平日各自忙於工作、家庭與論文，\n能坐下來的夜晚並不多。\n\n海風從窗外進來，\n酒一輪一輪地碰過去。",
    highlights: [
      "全南班集合",
      "夏林海產長桌晚宴",
      "學期回顧與下學期前瞻",
      "夜歸合影",
    ],
    tint: "warm",
    driveFolderId: "1rJZy-rKXGJjNA2FZLW-z_S7dHZNV07ao",
  },
  {
    id: "2026-05-03-otherworld-field-study",
    date: "2026-05-03",
    dateLabel: "2026.05.03",
    dateLong: "May 3, 2026",
    title: "歐樂沃築夢城堡",
    titleEn: "OTHERWORLD Field Study",
    cohortBand: "all",
    category: "visit",
    location: "嘉義縣大林鎮",
    summary:
      "走進歐樂沃築夢城堡，從企業故事、園區規劃到 Bean to Bar 巧克力體驗，\n把課堂之外的產業現場也收進班級記憶。",
    highlights: [
      "毛帥學長介紹分享",
      "Bean to Bar 巧克力故事導覽",
      "築夢城堡與園區經營觀察",
    ],
    tint: "sand",
    driveFolderId: "1nkTNdwbJ-lMucLNL3-soeYkWRH2GP31n",
    detailUrl: "https://field-study.e118.aqualux.dev",
    coverImage: "https://lh3.googleusercontent.com/d/1uJJwANvjOFXUMdRzzT17s85QrtnNt6Gt=w1600",
  },
  {
    id: "2026-03-14-cohort-mixer",
    date: "2026-03-14",
    dateLabel: "2026.03.14",
    dateLong: "March 14, 2026",
    title: "南北班相見歡",
    titleEn: "South–North Cohort Mixer",
    cohortBand: "all", // 全班
    category: "gathering",
    location: "台南 · 北安路 廚房有雞",
    summary:
      "三月十四日，南北兩班相約於台南北安路。\n廚房有雞——一家二十年的花雕雞老店。\n\n南班在台南，北班在台北，\n平日少有同席。\n那夜，大家初次圍坐一桌。\n\n花雕香氣升起，酒過三巡，\n方才認得彼此的名與臉。",
    highlights: [],
    tint: "cool",
    driveFolderId: "1FJ0cKow8Lof-gnBNWmPImoZvpoW1oM0m",
  },
];

export const ACTIVITY_BY_ID = Object.fromEntries(ACTIVITIES.map((a) => [a.id, a]));

// 為了向後相容，舊 component 引用 VISITS 的也支援
export const VISITS = ACTIVITIES;

// ─────────────────────────────────────────────────────────────
// 收納區（散影 / Moments）
//   湊不成一場活動的零碎照片，全部丟進「一個」Drive 資料夾即可，
//   系統會讀每張照片的 EXIF 拍攝時間（沒有就退回上傳時間）自動按月份分組。
//   ‼️ driveFolderId 為 null 時，散影入口不會出現在首頁（安全：誤推也不會壞）。
//      拿到散影資料夾 ID 後填到下面那一行即可上線。
//   ‼️ 若要讓同學能在站上「上傳照片」到散影，worker 的 ALLOWED_ACTIVITY_IDS 要加上 "moments"。
// ─────────────────────────────────────────────────────────────
export const COLLECTIONS = [
  {
    id: "moments",
    type: "moments",
    title: "散影",
    titleEn: "Moments",
    tagline: "課間與散席之後",
    blurb: "下課後再聊兩句，散席前再拍一張",
    summary:
      "那些湊不成一場活動的零碎照片——\n下課的續攤、走廊、課間、誰的生日。\n不分場次，依月份輕輕收著。",
    sub: "不必每張都有名字，記得就好。",
    tint: "ash",
    driveFolderId: "1Q5Gp-8ndbjfQ3IHxxMDTejWotmB6odPP", // 「E118 散影」資料夾（EMBA 帳號／全班群組檢視）
  },
];

export const COLLECTION_BY_ID = Object.fromEntries(COLLECTIONS.map((c) => [c.id, c]));
